import React from "react";
import moment from "moment";

const VistaDia = ({ events, currentDate, onChangeDate }) => {
  const selectedDate = currentDate;
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  // Mapeo de colores de fondo a colores de texto más oscuros
  const colorMapping = {
    "#e0e7ff": "#6366F1", // Morado claro -> Morado fuerte
    "#ede9fe": "#7C3AED", // Púrpura -> Púrpura oscuro
    "#bae6fd": "#0284C7", // Azul cielo -> Azul fuerte
    "#a7f3d0": "#059669", // Verde esmeralda -> Verde oscuro
    "#fecaca": "#DC2626", // Rojo claro -> Rojo fuerte
    "#fef9c3": "#A16207", // Amarillo claro -> Amarillo oscuro
  };

  // Filtrar los eventos que corresponden al día seleccionado
  const dayEvents = events.filter((event) =>
    moment(event.start).isSame(selectedDate, "day")
  );

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sección de agenda (horas y eventos) */}
      <div className="flex-[2] bg-white rounded-sm shadow-sm overflow-hidden flex flex-col">
        {/* Encabezado con la fecha completa */}
        <div className="p-5 border-b flex items-center">
          <div className="flex flex-col">
            <h1 className="text-2xl capitalize font-bold text-gray-500">
              {selectedDate.format("dddd, DD MMMM YYYY")}
            </h1>
          </div>
        </div>

        {/* Horas y eventos */}
        <div className="overflow-y-auto flex-1 p-4">
          {hours.map((hour) => (
            <div
              key={hour}
              className="border-b flex items-start py-4 hover:bg-gray-50"
            >
              <span className="w-24 text-sm text-gray-500 ml-4">{hour}</span>
              <div className="flex-1">
                {dayEvents
                  .filter(
                    (event) =>
                      moment(event.start).hour() ===
                      parseInt(hour.split(":")[0], 10)
                  )
                  .map((event) => {
                    const textColor =
                      event.resource === "tarea"
                        ? colorMapping[event.color] || "#1F2937" // Color de texto basado en el fondo
                        : "";

                    return (
                      <div
                        key={event.id}
                        className={`p-4 mb-2 rounded-sm shadow-sm text-sm transition-all duration-200 flex flex-col ${
                          event.resource === "cotizacion"
                            ? "bg-blue-100 text-blue-800"
                            : event.resource === "evento"
                            ? "bg-green-100 text-green-800"
                            : event.resource === "festivo"
                            ? "bg-red-100 text-red-800"
                            : event.resource === "tarea"
                            ? ""
                            : ""
                        }`}
                        style={{
                          backgroundColor:
                            event.resource === "tarea" ? event.color : "",
                          color: textColor,
                          fontWeight: "bold",
                        }}
                      >
                        <span className="text-xs font-bold mb-1">
                          {moment(event.start).format("h:mm A")}
                        </span>
                        <span className="font-semibold text-base">
                          {event.title}
                        </span>
                        {event.description && (
                          <p className="text-xs mt-1">{event.description}</p>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Calendario compacto lateral */}
      <div className="flex-[1.5] bg-white rounded-sm shadow-md ml-2 border overflow-hidden">
        {/* Encabezado del mini calendario */}
        <div className="p-4 border-b flex justify-between items-center bg-gray-100">
          <button
            onClick={() =>
              onChangeDate(selectedDate.clone().subtract(1, "month"))
            }
            className="text-gray-600 hover:text-gray-800 text-xl"
          >
            <i className="bi bi-chevron-left"></i>
          </button>
          <h2 className="text-xl font-bold text-gray-800 capitalize">
            {selectedDate.format("MMMM YYYY")}
          </h2>
          <button
            onClick={() => onChangeDate(selectedDate.clone().add(1, "month"))}
            className="text-gray-600 hover:text-gray-800 text-xl"
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>

        {/* Días del mes con líneas y mayor tamaño */}
        <div className="grid grid-cols-7 text-center text-md font-semibold">
          {["L", "M", "M", "J", "V", "S", "D"].map((day, index) => (
            <div
              key={index}
              className="p-4 border-b border-r bg-gray-100 text-gray-600 uppercase tracking-wide"
            >
              {day}
            </div>
          ))}
          {Array.from({ length: 42 }, (_, index) => {
            const day = moment(selectedDate)
              .startOf("month")
              .startOf("week")
              .add(index, "day");
            return (
              <div
                key={index}
                className={`flex items-center justify-center h-20 cursor-pointer border-b border-r transition-all duration-200 text-md ${
                  day.isSame(selectedDate, "day")
                    ? "bg-blue-500 text-white font-bold shadow-md"
                    : day.isSame(selectedDate, "month")
                    ? "hover:bg-gray-200 text-gray-800"
                    : "text-gray-400"
                }`}
                onClick={() => onChangeDate(day)}
              >
                {day.date()}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VistaDia;
